module.exports = __webpack_public_path__ + "img/renewable-energy.4a54635b.svg";